import { ButtonBallColor } from '../types';

interface Props {
  animated?: boolean;
  color?: ButtonBallColor;
}

const ColoredBall = ({ animated, color = 'red' }: Props) => {
  let bgColor = 'bg-[#FF102C]';
  if (color === 'white') {
    bgColor = 'bg-white group-hover:bg-white/80';
  }
  return <div className={`h-2 w-2 rounded-full ${bgColor} ${animated ? 'animate-bounce' : ''}`} />;
};
export default ColoredBall;
